import { Component, EventEmitter, Input, Output } from "@angular/core";
@Component({
  selector: "app-key-account-select",
  templateUrl: "./key-account-select.component.html",
  styleUrl: "./key-account-select.component.scss",
})
export class KeyAccountSelectComponent {
  @Input() selectedKeyAccount: any = null;
  @Input() optionsList: any[] = [];
  @Output() onSelectKeyAccount = new EventEmitter<any>();
  @Output() onClearKeyAccount = new EventEmitter<any>();
  @Output() completeMethod = new EventEmitter<any>();

  displayValue = "";

  searchKeyAccount(event: any) {
    this.completeMethod.emit(event);
  }

  selectKeyAccount(event: any) {
    this.onSelectKeyAccount.emit(event);
  }

  clearKeyAccount() {
    this.onClearKeyAccount.emit(true);
  }
}
